import { AuthState, initialAuthState } from './auth.state';
import { AuthActionTypes, AuthActions } from './auth.actions';

export function authReducer(state: AuthState = initialAuthState, action: AuthActions): AuthState {
	switch (action.type) {
		case AuthActionTypes.LoadStorage:
		case AuthActionTypes.Load:
		case AuthActionTypes.Logout:
		case AuthActionTypes.UpdateCoordinates:
			return {
				...state,
				loading: true
			};
		case AuthActionTypes.LoginOk:
		case AuthActionTypes.TokenRefreshed:
			return {
				...state,
				loading: false,
				access_token: action.response.access_token,
				refresh_token: action.response.refresh_token
			};
		// Still loading: a new anonymous user follows (ID-8).
		case AuthActionTypes.SignedOut:
			return {
				...state,
				loading: true,
				currentUser: null,
				access_token: null,
				refresh_token: null,
				anonymous_token: null
			};
		case AuthActionTypes.AnonymousSessionOk:
			return {
				...state,
				anonymous_token: action.anonymousToken
			};
		case AuthActionTypes.AnonymousSessionEnded:
			return {
				...state,
				anonymous_token: null
			};
		case AuthActionTypes.LoadOk:
			return {
				...state,
				loading: false,
				currentUser: action.response
			};
		// The server answers with the refreshed copy, so this replaces the user rather than patching fields.
		case AuthActionTypes.RefreshProfileOk:
			return {
				...state,
				currentUser: action.response
			};
		case AuthActionTypes.LoginFail:
			return {
				...state,
				loading: false
			};
		case AuthActionTypes.LoadStorageOk:
			if (action.store && action.store.auth) {
				return {
					location: state.location, // Keep current location
					...action.store.auth
				};
			} else {
				return state;
			}
		case AuthActionTypes.UpdateCoordinatesOk:
			return {
				...state,
				location: {
					latitude: action.latitude,
					longitude: action.longitude
				}
			};
		case AuthActionTypes.LoadFail:
		case AuthActionTypes.AnonymousSessionFail:
		case AuthActionTypes.LoadStorageFail:
		case AuthActionTypes.RefreshProfileFail:
		case AuthActionTypes.UpdateCoordinatesFail:
			return {
				...state,
				loading: false
			};
		default:
			return state;
	}
}
